import * as stylex from "@stylexjs/stylex";
import { Droplet } from "lucide-react";
import type { WeatherIcon } from "@/domain/schemas";
import "@/theme/tokens.stylex";
import { colors, motion, radii, space } from "@/theme/tokens.stylex";
import "@/theme/type.stylex";
import { type } from "@/theme/type.stylex";
import { Icon } from "./Icon";
import { press } from "./press";
import { weatherIcons } from "./weatherIcons";
type ForecastDayProps = {
  day: string;
  icon: WeatherIcon;
  iconLabel?: string;
  high: number;
  low: number;
  precip?: number;
  active?: boolean;
  onClick?: () => void;
  xstyle?: stylex.StyleXStyles;
};
const styles = {
  root: {
    kMzoRj: "xc342km",
    kVVagm: "xln7xf2",
    kMwMTN: "x1a11ngh",
    k9WMMc: "x2b8uid",
    kWkggS: "xjbqb8w",
    kaIpWk: "x1fv5t7x",
    k8WAf4: "xpt0qjj",
    kg3NbH: "xw3ndq7",
    k1xSpc: "x78zum5",
    kXwgrk: "xdt5ytf",
    kGNEyG: "x6s0dn4",
    kOIVth: "xddi9bj",
    k7Eaqz: "xeuugli",
    k1ekBW: "xuo13n2",
    kIyJzY: "x2lra08",
    kAMwcw: "x1em5f5i",
    $$css: true
  },
  button: {
    kkrTdU: "x1ypdohk",
    $$css: true
  },
  active: {
    kWkggS: "xh540kj",
    $$css: true
  }
};
export function ForecastDay({
  day,
  icon,
  iconLabel,
  high,
  low,
  precip,
  active,
  onClick,
  xstyle
}: ForecastDayProps) {
  const rootStyles = [styles.root, active && styles.active];
  const content = <>
      <span className="xr0iwhn xucc2r2 xlin7pe xtvhhri">{day}</span>
      <Icon icon={weatherIcons[icon]} size={48} label={iconLabel} />
      <span className="x78zum5 xdt5ytf x195vfkc">
        <span className="x1s3cmhv x1cf7cre xcwzsbu x1159mfc">{high}°</span>
        <span className="xwsyq91 x15i68ds x1u7k74">{low}°</span>
      </span>
      {precip !== undefined && <span className="xr0iwhn xhunfcg xt3et7w x78zum5 xt4j9g6 x6s0dn4">
          <Icon icon={Droplet} size={12} />
          {precip}%
        </span>}
    </>;
  if (onClick) {
    return <button type="button" onClick={onClick} {...stylex.props(...rootStyles, styles.button, press.scale, xstyle)}>
        {content}
      </button>;
  }
  return <div {...stylex.props(...rootStyles, xstyle)}>{content}</div>;
}